/**
 * Interface for BO WidgetService
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const FilterType = {
    Checkbox: 'checkbox',
    Radio: 'radio',
    String: 'string',
    Listbox: 'listbox',
    Combobox: 'combobox',
} as const;
export type FilterType = typeof FilterType[keyof typeof FilterType];

